module.exports = __webpack_public_path__ + "static/media/chant.a659d2a0.jpg";